import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep cached data fresh for 2 minutes
      staleTime: 2 * 60 * 1000,
      // Keep unused cache for 5 minutes
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        // Don't retry on 401 or 403
        if ([401, 403].includes(error?.response?.status)) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
